import { CompanyForm } from '../../components';

const CompanyPage = () => {
  return <CompanyForm />;
};

export default CompanyPage;
